/**
 * useChannelBullets — read current Bullet1..5 values for a product/channel.
 *
 * Backed by GET /api/v1/products/{productId}/channels/{channelId}/bullets which
 * resolves workspace_integrations.config.bullet_mapping → JTL custom-fields.
 *
 * Used by the RemakeApply content flow to populate the side-by-side current
 * column for bullets (matching read path for the channel-editor stack).
 */

import { useQuery } from '@tanstack/react-query'
import { getChannelBullets, type ChannelBulletsResponse } from '@/lib/api/products'

export function useChannelBullets(
  productId: string | null | undefined,
  channelId: string | null | undefined,
) {
  return useQuery<ChannelBulletsResponse>({
    queryKey: ['channel-bullets', productId, channelId],
    queryFn: () => getChannelBullets(productId as string, channelId as string),
    enabled: !!productId && !!channelId,
    staleTime: 30_000,
  })
}
